import React, { Component } from 'react';
import RouteComponent from '../../Route';
import branchAdminConfig from '../../../../utils/routes/config/branch_admin_config';

/**
 * @inheritdoc
 */
class BranchAdminLayout extends Component {
    render() {
        return <RouteComponent routes={branchAdminConfig} />;
    }
}

export default BranchAdminLayout;
